// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".native-list-offer[data-v-13c531b6]{position:absolute;top:0;left:0;right:0;bottom:0;z-index:10;pointer-events:none;display:none}.native-list-offer--rendered[data-v-13c531b6]{display:block;pointer-events:all}.native-list-offer__container[data-v-13c531b6]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
